<template>
  <body>
    <p>
      <span>Some video art I've made over the years</span>
    </p>
    <div
      class="videos-container"
      style="margin-top: 1rem;"
    >
      <div class="row">
        <div class="col-lg-6">
          <div class="embed-responsive embed-responsive-16by9 video">
            <iframe
              src="https://www.youtube.com/embed/RYR9TlCXIaA"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="embed-responsive embed-responsive-16by9 video">
            <iframe
              src="https://www.youtube.com/embed/M2SdNY_0DXY"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="embed-responsive embed-responsive-16by9 video">
            <iframe
              src="https://www.youtube.com/embed/xxev66v7Im4"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="embed-responsive embed-responsive-16by9 video">
            <iframe
              src="https://www.youtube.com/embed/EZap0iw-ZUo"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="embed-responsive embed-responsive-16by9 video">
            <iframe
              src="https://www.youtube.com/embed/qeO7T88pNZY"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="embed-responsive embed-responsive-16by9 video">
            <iframe
              src="https://www.youtube.com/embed/MWtxR5luo0E"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-6">
          <div class="embed-responsive embed-responsive-16by9 video">
            <iframe
              src="https://www.youtube.com/embed/KCB9hupA_qI"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </div>
        </div>
        <div class="col-lg-6">
          <div class="embed-responsive embed-responsive-16by9 video">
            <iframe
              src="https://www.youtube.com/embed/tuxPLFtyGb0"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
            />
          </div>
        </div>
      </div>
    </div>
  </body>
</template>

<script>
import videoInfo from '../data/video_info.json';

export default {
  name: 'Videos',
  data() {
    return {
      showMoreInfo: false,
      video_info: videoInfo,
      showMoreText: 'show more',
    }
  },
};
</script>

<style lang="scss" scoped>
/* TODO: animated borders */

$iframe-width: 95vh;
$sm: 540px;
$md: 720px;
$lg: 960px;
$xl: 1140px;

body {
  border-color: rgb(35, 35, 252);
  border-style: dotted;
  border-spacing: 1em;
  font-family: 'Russo One', sans-serif;
  background-color: black;
  text-align: center;
  margin: .55rem;
}

h1, h2, h3, a {
  text-align: center;
}

p > span {
  border: 1px dashed gray;
  line-height: 20px;
  text-shadow: none;
  @media(max-width: $md) {
    font-size: 1rem;
  }
}

.show-more-btn {
  color: rgb(35, 35, 252);
  border-color: rgb(35, 35, 252);
  box-shadow: 0px 2px rgba(190, 36, 190, 0.5);
  background-color: black;
}

.show-more-btn:hover {
  filter: brightness(60%);
}

.video {
  border-color: black;
  border-width: 1.5px;
  border-style: solid;
  margin-bottom: 1rem;
}

.video:hover {
  border-color: orange;
}

#back-button:hover {
  color: rgb(35, 35, 252);
}

.main-header {
  @include text-outline(4.5px);
}

.more-info {
  background-color: black;
  border: 3px blue solid;
  width: fit-content;
  margin-left: auto;
  margin-right: auto;
  padding: 1em;
}

.videos-container {
  border: 1px solid gray;
  max-height: calc(67.5vh - 25px);
  @media (-webkit-min-device-pixel-ratio: 1.25), (min-resolution: 1.25dppx), (min-resolution: 120dpi){
    max-height: calc(57.5vh - 26px);
  } 
   @media (-webkit-min-device-pixel-ratio: 1.5), (min-resolution: 1.5dppx), (min-resolution: 144dpi){
    max-height: 55vh;
  }
  @media screen and (max-width: $sm) {
    max-height: 40vh;
  }
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  // -ms-overflow-style: none;  /* IE and Edge */
  // scrollbar-width: none;  /* Firefox */
  // scrollbar-color:  black rgba(0,0,0,.05);
  scrollbar-color:  black white;
}

.videos-container::-webkit-scrollbar {
  display: none;
}


</style>